// src/components/common/AppLogo.jsx
import React from 'react';

const AppLogo = ({ size = 36, className = '' }) => (
  <img
    src="/icons/logo.png"
    alt="WANETERE"
    width={size}
    height={size}
    className={`rounded-xl object-cover flex-shrink-0 ${className}`}
  />
);

export default AppLogo;
